import { AppDialog, FormField, TextareaField } from "@/components/common";
import { Button } from "@/components/ui/button";
import { useESGCollaborationStore } from "@/features/esg/hooks/useESGReportStore";
import { DelegationSchema } from "@/features/esg/schemas/esg.schema";
import { useTran } from "@/hooks";
import { Form, Formik } from "formik";
import { observer } from "mobx-react-lite";
import { useRef } from "react";

const DelegateEntryDialog = observer(
  ({ open, onOpenChange, code, entryId, entryLabel }) => {
    const { t } = useTran();
    const formikRef = useRef();
    const { sendEntryDelegation, getEntryDelegation } =
      useESGCollaborationStore();

    const existingDelegation = getEntryDelegation(code, entryId);

    const handleCancel = () => {
      onOpenChange(false);
    };

    const handleSubmit = async (values) => {
      await sendEntryDelegation(code, entryId, values);
      handleCancel();
    };

    return (
      <AppDialog
        size="md"
        open={open}
        onOpenChange={onOpenChange}
        title={t("Delegate Entry")}
        description={t(
          "Delegate this entry to another user for data input. They will receive an email notification.",
        )}
        footer={
          <div className="flex gap-x-2 items-center justify-end">
            <Button variant="outline" onClick={handleCancel}>
              {t("Cancel")}
            </Button>
            <Button onClick={() => formikRef.current.submitForm()}>
              {t("Confirm")}
            </Button>
          </div>
        }
      >
        <div className="space-y-3">
          {entryLabel && (
            <div className="p-3 bg-muted rounded-md">
              <p className="text-xs text-muted-foreground">{t("Entry")}</p>
              <p className="text-sm font-medium">
                {code} - {entryLabel}
              </p>
            </div>
          )}
          <Formik
            initialValues={{
              email: existingDelegation?.email || "",
              message: existingDelegation?.message || "",
            }}
            enableReinitialize
            innerRef={formikRef}
            validationSchema={DelegationSchema}
            onSubmit={handleSubmit}
          >
            {({ errors, touched, values, handleChange }) => (
              <Form className="space-y-3">
                <FormField
                  name="email"
                  label={t("Email")}
                  placeholder={t("Email")}
                  value={values.email}
                  onChange={handleChange}
                  error={touched.email && errors.email}
                  required
                />
                <TextareaField
                  name="message"
                  label={t("Message")}
                  placeholder={t("Message")}
                  value={values.message}
                  onChange={handleChange}
                  error={touched.message && errors.message}
                />
              </Form>
            )}
          </Formik>
        </div>
      </AppDialog>
    );
  },
);

export default DelegateEntryDialog;
